import * as React from 'react';
import { LinkButton, useDeviceType, UIText3 } from '@cian/ui-kit';
import * as style from './CianMortgageButton.css';
import { NBSP } from '../../constants/symbols';

interface ICianMortgageButtonProps {
  url: string;
  text: string;
  onClick(): void;
}

export const CianMortgageButton: React.FC<ICianMortgageButtonProps> = props => {
  const { url, text, onClick } = props;

  const deviceType = useDeviceType();
  /* istanbul ignore next */
  const buttonSize = deviceType === 'phone' ? 'L' : 'M';
  /* istanbul ignore next */
  const descriptionTextAlign = deviceType === 'phone' ? 'center' : 'right';

  return (
    <div className={style['cian-mortgage-button']}>
      <LinkButton
        theme="fill_primary"
        href={url}
        size={buttonSize}
        onClick={onClick}
        fullWidth={deviceType === 'phone'}
        data-testid="CianMortgageButton"
        target="_blank"
      >
        {text}
      </LinkButton>
      <div className={style['description']}>
        <UIText3 color="text-secondary-default" textAlign={descriptionTextAlign}>
          Заявка{NBSP}— единая для всех банков. Не оферта. Перед{NBSP}заполнением попросим авторизоваться.
        </UIText3>
      </div>
    </div>
  );
};
